import { render, staticRenderFns } from "./ed-popup-menu-item.component.vue?vue&type=template&id=664ff1d5&scoped=true&"
import script from "./ed-popup-menu-item.component.ts?vue&type=script&lang=ts&"
export * from "./ed-popup-menu-item.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-popup-menu-item.component.scss?vue&type=style&index=0&id=664ff1d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664ff1d5",
  null
  
)

export default component.exports